import React, { memo } from 'react';
import { Blok } from '../../../../interfaces/Blok.interface';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';

interface QuoteStageConditionalContentBlokProps extends Blok {
  body: Blok[];
  show_for_quote_type:
    | 'buying'
    | 'selling'
    | 'buying-and-selling'
    | 'remortgage';
}

interface QuoteStageConditionalContentProps {
  blok: QuoteStageConditionalContentBlokProps;
}

const QuoteStageConditionalContent: React.FC<
  QuoteStageConditionalContentProps
> = ({ blok }) => {
  const { body } = blok;

  return (
    <div {...storyblokEditable(blok)}>
      {body.map((blok: Blok) => (
        <StoryblokComponent blok={blok} key={blok._uid} />
      ))}
    </div>
  );
};

export default memo(QuoteStageConditionalContent);
